import React from 'react';
import TocRoundedIcon from '@mui/icons-material/TocRounded';
import CurrencyExchangeRoundedIcon from '@mui/icons-material/CurrencyExchangeRounded';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import AccessibilityTwoToneIcon from '@mui/icons-material/AccessibilityTwoTone';
import PaletteTwoToneIcon from '@mui/icons-material/PaletteTwoTone';
import ReviewsTwoToneIcon from '@mui/icons-material/ReviewsTwoTone';
import FactCheckTwoToneIcon from '@mui/icons-material/FactCheckTwoTone';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import MonetizationOnTwoToneIcon from '@mui/icons-material/MonetizationOnTwoTone';
import SportsSoccerTwoToneIcon from '@mui/icons-material/SportsSoccerTwoTone';
import CommentTwoToneIcon from '@mui/icons-material/CommentTwoTone';
import CollectionsTwoToneIcon from '@mui/icons-material/CollectionsTwoTone';
import AccountBalanceWalletTwoToneIcon from '@mui/icons-material/AccountBalanceWalletTwoTone';
import ContactMailTwoToneIcon from '@mui/icons-material/ContactMailTwoTone';
import GTranslateTwoToneIcon from '@mui/icons-material/GTranslateTwoTone';
import ManageAccountsTwoToneIcon from '@mui/icons-material/ManageAccountsTwoTone';
import PlaceTwoToneIcon from '@mui/icons-material/PlaceTwoTone';
import ViewCarouselTwoToneIcon from '@mui/icons-material/ViewCarouselTwoTone';
import CasinoTwoToneIcon from '@mui/icons-material/CasinoTwoTone';
import AssessmentTwoToneIcon from '@mui/icons-material/AssessmentTwoTone';
import LiveTvTwoToneIcon from '@mui/icons-material/LiveTvTwoTone';
import SynagogueTwoToneIcon from '@mui/icons-material/SynagogueTwoTone';
import LocalAtmTwoToneIcon from '@mui/icons-material/LocalAtmTwoTone';
import CardMembershipTwoToneIcon from '@mui/icons-material/CardMembershipTwoTone';
import SpeakerNotesTwoToneIcon from '@mui/icons-material/SpeakerNotesTwoTone';
import LocationOffTwoToneIcon from '@mui/icons-material/LocationOffTwoTone';
import QrCode2TwoToneIcon from '@mui/icons-material/QrCode2TwoTone';
import PsychologyTwoToneIcon from '@mui/icons-material/PsychologyTwoTone';
import ManageHistoryTwoToneIcon from '@mui/icons-material/ManageHistoryTwoTone';

export const profileConstants = [
  { key: 'First Name', value: 'firstName', edit: true },
  { key: 'Last Name', value: 'lastName', edit: true },
  { key: 'Email', value: 'email' },
  { key: 'User Name', value: 'adminUsername' },
  { key: 'Role', value: 'AdminRole', subValue: 'name' },
  { key: 'Group', value: 'group' }
]

export const siteConfigConstants = [
  { key: 'Site  Name', value: 'name', edit: true , type: 'text' },
  { key: 'Site  Url', value: 'url', edit: true, type: 'text'  },
  // { key: 'Site  Logo', value: 'logo', edit: true , type: 'file' },
  
  // { key: 'Support Email Address', value: 'supportEmail', edit: true },
  // { key: 'Mail Gun Email', value: 'sendgridEmail', edit: true },
  // { key: 'Mail Gun Domain', value: 'sendgridKey', edit: true },

  // { key: 'Minimum Reedemable Coins', value: 'languages',edit: true  },
  // { key: 'Site Logo', value: 'logo',edit: true  }
]

export const adminConfigConstants = [
  {
    key: "Deposit Transaction Time Limit (in minutes)",
    value: 'DEPOSIT_TRANSACTION_TIME_LIMIT',
    edit: true,
    info: "The time will limit specific transaction's currency conversion.",
    type: 'number'
  },
  {
    key: "Low Wallet Amount (USD)",
    value: 'LOW_WALLET_AMOUNT',
    edit: true,
    info: "The threshold amount for which the player will be notified to deposit.",
    type: 'number'
  },
  {
    key: "Maximum Deposit Amount for VIP (TTD)",
    value: 'MAXIMUM_DEPOSIT_LIMIT',
    edit: true,
    // info: "The threshold amount for which the player will be notified to deposit.",
    type: 'number'
  },
  {
    key: "Withdrawal in Cash (USD)",
    value: 'WITHDRAWAL_IN_CASH',
    edit: true,
    info: "Enable or disable cash withdrawal functionality.",
    type: 'select',
    options: [
      { value: 'true', label: 'Enable' },
      { value: 'false', label: 'Disable' }
    ]
  },
  {
    key: "Whatsapp Number",
    value: 'WHATSAPP_NUMBER',
    edit: true,
    info: "This number will be used for further communications and important updates.",
    type: 'text'
  },
];


export const socialMediaConfigConstants = [
 
  
  {
    key: "Facebook Link",
    value: 'FACEBOOK_LINK',
    edit: true,
    info: "The URL of your official Facebook page.",
    type: 'text'
  },
  {
    key: "TikTok Link",
    value: 'TIKTOK_LINK',
    edit: true,
    info: "The URL of your official TikTok account.",
    type: 'text'
  },
  {
    key: "Twitter Link",
    value: 'TWITTER_LINK',
    edit: true,
    info: "The URL of your official Twitter account.",
    type: 'text'
  },
  {
    key: "YouTube Link",
    value: 'YOUTUBE_LINK',
    edit: true,
    info: "The URL of your official YouTube channel.",
    type: 'text'
  },
  {
    key: "Instagram Link",
    value: 'INSTAGRAM_LINK',
    edit: true,
    info: "The URL of your official Instagram channel.",
    type: 'text'
  }
];


export const profileConstantsTA = [
  { key: 'First Name', value: 'firstName', edit: true },
  { key: 'Last Name', value: 'lastName', edit: true },
  { key: 'Email', value: 'email' },
  { key: 'Phone', value: 'phone', edit: true },
  { key: 'Role', value: 'AdminRole', subValue: 'name' },
  { key: 'Username', value: 'agentName' },
  { key: 'Group', value: 'group' }
]

export const permissionLabel = (label) => {
  switch (label) {
    case 'C':
      return 'Create'
    case 'R':
      return 'Read'
    case 'U':
      return 'Update'
    case 'D':
      return 'Delete'
    case 'T':
      return 'Toggle Status'
    case 'A':
      return 'Apply'
    case 'CC':
      return 'Create Custom'
    case 'AB':
      return 'Manage Money'
    case 'SR':
      return 'Limit'
    case 'TE':
      return 'Test Email'
    case 'EV':
      return 'Verify Email'
    case 'UP':
      return 'Reset Password'
    default:
      return label
  }
}

// Bonus configurations with unique field keys and slugs
export const BONUS_CONFIGS = [
  {
    title: "FreeBet Bonus",
    slug: "freebet",
    // trigger: "After a player makes a $100 bet, get a $20 free bet",
    fields: [
      {
        key: "Wager Amount",
        value: "freebet_wager_amount",
        info: "Player must place bets with at least this minimum wager amount to be eligible for the bonus.",
        type: "number",
      },
      {
        key: "Number of Free Bets",
        value: "freebet_no_of_free_bet",
        info: " This is the total number of free bets a user can receive from this bonus",
        type: "number",
      },
      {
        key: "Bonus Amount",
        value: "freebet_bonus_amount",
        // info: "The bonus amount credited for the free bet (minimum $20).",
        type: "number",
      },
      {
        key: "Is Active",
        value: "freebet_is_active",
        // info: "Whether the free bet bonus is active or not.",
        type: "select",
        options: [
          { value: "true", label: "True" },
          { value: "false", label: "False" },
        ],
      },
    ],
  },
  {
    title: "Deposit Bonus",
    slug: "deposit_bonus",
    // trigger: "On first deposit, get 10% of deposit amount for 1st month, then 5%",
    fields: [
      {
        key: "Bonus Amount",
        value: "deposit_bonus_amount",
        // info: "The percentage of the deposit credited as a bonus (e.g., 10% or 5%).",
        type: "number",
      },
      {
        key: "Is Active",
        value: "deposit_is_active",
        // info: "Whether the deposit bonus is active or not.",
        type: "select",
        options: [
          { value: "true", label: "True" },
          { value: "false", label: "False" },
        ],
      },
    ],
  },
  {
    title: "Cashback Bonus",
    slug: "cashback_bonus",
    // trigger: "After a $500 bet is placed",
    fields: [
      // {
      //   key: "Bonus Amount",
      //   value: "cashback_bonus_amount",
      //   // info: "The cashback amount credited after the wager threshold.",
      //   type: "number",
      // },
      {
        key: "Wager Amount",
        value: "cashback_wager_amount",
        info: "Player must place bets with at least this minimum wager amount to be eligible for the bonus.",

        type: "number",
      },
      {
        key: "Is Active",
        value: "cashback_is_active",
        // info: "Whether the cashback bonus is active or not.",
        type: "select",
        options: [
          { value: "true", label: "True" },
          { value: "false", label: "False" },
        ],
      },
      {
        key: "Number of Cashback Bets",
        value: "cashback_no_of_cashback_bet",
        info: "This is the total number of Cashback bets a user can receive from this bonus",
        type: "number",
      },
     
    ],
  },
  {
    title: "Risk Free Bet",
    slug: "risk_free_bet",
    // trigger: "When user places 5 bets",
    fields: [
      {
        key: "RFB Threshold",
        value: "rfb_thresold",
        info: "Player must place bets with at least this minimum wager amount to be eligible for the bonus.",

        type: "number",
      },
      {
        key: "RFB Bonus Amount",
        value: "rfb_bonus_amount",
        // info: "The number of bets required to trigger the risk-free bet (minimum 5).",
        type: "number",
      },
      {
        key: "Number of RFBs",
        value: "rfb_no_of_rfb",
        info: " This is the total number of Risk free bets a user can receive from this bonus",
        // info: "The number of risk-free bets awarded.",
        type: "number",
      },
      {
        key: "Is Active",
        value: "rfb_is_active",
        // info: "Whether the risk-free bet bonus is active or not.",
        type: "select",
        options: [
          { value: "true", label: "True" },
          { value: "false", label: "False" },
        ],
      },
    ],
  },
  {
    title: "Conditional Risk Free Bet",
    slug: "conditional_risk_free_bet",
    // trigger: "Same as Risk Free Bet (when user places 5 bets)",
    fields: [
      {
        key: "CRFB Threshold",
        value: "crfb_thresold",
        info: "Player must place bets with at least this minimum wager amount to be eligible for the bonus.",

        type: "number",
      },
      {
        key: "Number of CRFBs",
        value: "crfb_no_of_crfb",
        info: "This is the total number of Conditional free bets a user can receive from this bonus",
        type: "number",
      },
      {
        key: "Is Active",
        value: "crfb_is_active",
        // info: "Whether the conditional risk-free bet bonus is active or not.",
        type: "select",
        options: [
          { value: "true", label: "True" },
          { value: "false", label: "False" },
        ],
      },
    ],
  },
];

export const permissionIcons = () => {
  return (
    {
      CMS: <TocRoundedIcon />,
      Bonus: <CurrencyExchangeRoundedIcon />,
      Users: <PeopleOutlineRoundedIcon />,
      Admins: <AdminPanelSettingsRoundedIcon />,
      Tenant: <AccessibilityTwoToneIcon />,
      Themes: <PaletteTwoToneIcon />,
      Reviews: <ReviewsTwoToneIcon />,
      KycLabel: <FactCheckTwoToneIcon />,
      KpiReport: <ReceiptLongTwoToneIcon />,
      Currencies: <MonetizationOnTwoToneIcon />,
      GameReport: <SportsSoccerTwoToneIcon />,
      UserComment: <CommentTwoToneIcon />,
      ImageGallery: <CollectionsTwoToneIcon />,
      Transactions: <AccountBalanceWalletTwoToneIcon />,
      EmailTemplate: <ContactMailTwoToneIcon />,
      MultiLanguage: <GTranslateTwoToneIcon />,
      TenantSettings: <ManageAccountsTwoToneIcon />,
      DemographReport: <PlaceTwoToneIcon />,
      BannerManagement: <ViewCarouselTwoToneIcon />,
      CasinoManagement: <CasinoTwoToneIcon />,
      KpiSummaryReport: <AssessmentTwoToneIcon />,
      LivePlayerReport: <LiveTvTwoToneIcon />,
      WageringTemplate: <SynagogueTwoToneIcon />,
      CashierManagement: <LocalAtmTwoToneIcon />,
      LoyaltyManagement: <CardMembershipTwoToneIcon />,
      RegistrationField: <SpeakerNotesTwoToneIcon />,
      RestrictedCountry: <LocationOffTwoToneIcon />,
      TenantCredentials: <QrCode2TwoToneIcon />,
      TenantConfigurations: <PsychologyTwoToneIcon />,
      PlayerLiabilityReport: <AssessmentTwoToneIcon />,
      PlayerManagementReport: <ManageHistoryTwoToneIcon />,
    }
  )
}